import { PatientRawResponses } from "~/providers/components";

export const LeadPatientRawResponses = () => <PatientRawResponses />;
